import React, { Component } from 'react';
import './DashboardErrorBoundary.scss';

class DashboardErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null, errorInfo: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		this.setState({
			error: error,
			errorInfo: errorInfo,
		});
		console.error('Dashboard Error:', error);
		console.error('Error Info:', errorInfo);
	}

	handleRetry = () => {
		this.setState({ hasError: false, error: null, errorInfo: null });
	};

	render() {
		if (this.state.hasError) {
			return (
				<div className="dashboard-error-boundary">
					<div className="error-content">
						<div className="error-icon">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="64"
								height="64"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							>
								<circle cx="12" cy="12" r="10"></circle>
								<line x1="12" y1="8" x2="12" y2="12"></line>
								<line x1="12" y1="16" x2="12.01" y2="16"></line>
							</svg>
						</div>
						<h2>Dashboard Error</h2>
						<p>Something went wrong while loading the dashboard.</p>
						<p className="error-details">
							{this.state.error && this.state.error.toString()}
						</p>
						<button className="retry-button" onClick={this.handleRetry}>
							Try Again
						</button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

export default DashboardErrorBoundary;
